import type { OwnerResource } from "../../owner";
import type { AccountingAccountResource } from "../../accounting-account";

export interface BankAccountSettingsResource {
  id: string;
  bank_account_id: string;
  iban: string | null;
  bic: string | null;
  sepa_number: string | null;
  bank_name: string | null;
  bank_account_number: string | null;
}
export interface PaypalAccountSettingsResource {
  id: string;
  bank_account_id: string;
  signature: string | null;
  username: string | null;
  password: string | null;
  email: string | null;
  client_id: string | null;
  client_secret: string | null;
}

export enum BankAccountType {
  Bank = "bank",
  Paypal = "paypal",
}
export interface BankAccountResource {
  id: string;
  account_type: BankAccountType;
  name: string;
  owner_id: string;
  owner?: OwnerResource;
  bankAccountSettings?: BankAccountSettingsResource;
  paypalAccountSettings?: PaypalAccountSettingsResource;
  accountingAccount?: AccountingAccountResource;
  accounting_account_id: string | null;
}

export type UpdateBankAccountRequest = {
  title?: string;
  country_code?: string;
  vat_percent?: number;
  is_default?: boolean;
};

export type StoreBankAccountRequest = {
  title?: string;
  country_code?: string;
  vat_percent?: number;
  is_default?: boolean;
};
